<template>
<m-pageframe
    title="Table Test"
>
<v-container
    fluid
>
    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="foo(headers, results)"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.some_field="{ item }">
            {{item.some_field}}
        </template>
    
    </v-data-table>

    <v-btn
        v-on:click="onClickAdd"
    >
        Add
    </v-btn>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            headers: [
                { text: 'Date', value: 'date_date', compute: (item) => this.$rc.pretty(item.time,'date')  },
                { text: 'Time', value: 'date_time', compute: (item) => this.$rc.pretty(item.time,'time') },
                { text: 'Name', value: 'name' },
            ],

            results: [
                { 'time': 1708551448240, 'name': 'Jim Kane' },
            ],
        };
    },

    methods: {
        foo(headers, items) {
            return items.map((item) => {
                item = _.cloneDeep(item);

                headers.forEach((column) => {
                    
                    if ( column.compute != null )
                    {
                        item[column.value] = column.compute(item);
                    }

                });


                return item;
            });
        },

        onClickAdd()
        {
            this.results.push({ 'time': 1708551448240, 'name': 'Tom Jones' });
        },
    },
}
</script>

<style lang="scss" scoped>
</style>